// user.js
import store from "@/store";
import router from "@/router";
import util from "./util";
import { Toast } from "@vant/compat";

const checkAuth = async function (failMsg = null) {
  var authResult = await store.dispatch("checkAuthStatus");
  if (!authResult) {
    if (!util.isBlank(failMsg)) {
      alert(failMsg);
    }

    router.push("/");
  }
  return authResult;
};

export default {
  checkAuth,
};
